import { mutatorAction } from 'satcheljs';
import getFeedbackRibbonState from '../selectors/getFeedbackRibbonState';

export let setShowMoreFeedbackMessage = mutatorAction(
    'setShowMoreFeedbackMessage',
    (showMoreFeedbackMessage: boolean, sessionId: string) => {
        getFeedbackRibbonState(sessionId).showMoreFeedbackMessage = showMoreFeedbackMessage;
    }
);
